import Request from '@/plugins/request';

export function getInStorages(params) {
  return Request.get('in-storages', { params })
}

export function createInStorage() {
  return Request.get(`in-storages/create`)
}

export function storeInStorage(data) {
  return Request.post('in-storages', data)
}

export function updateInStorage(id, data) {
  return Request.put(`in-storages/${id}`, data)
}

export function editInStorage(id) {
  return Request.get(`in-storages/${id}/edit`)
}

export function destroyInStorage(id) {
  return Request.delete(`in-storages/${id}`)
}
